import {FormApi, FormState} from 'final-form';
import React, {ComponentType} from 'react';
import {useForm, useFormState} from 'react-final-form';
import hoistNonReactStatics from 'hoist-non-react-statics';

export interface WithFinalForm<T> {
    formApi: FormApi<T>;
    formState: FormState<T>;
}

export default function withFinalForm<FormValues>() {
    return function <T extends WithFinalForm<FormValues>>(
        Component: ComponentType<T>,
    ): ComponentType<T> {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const WithFinalForm: React.FC<T> = (props) => {
            const formApi = useForm<FormValues>();
            const formState = useFormState<FormValues>();
            return <Component {...props} formApi={formApi} formState={formState} />;
        };

        WithFinalForm.displayName = `withFinalForm(${
            Component.displayName || Component.name || 'Component'
        })`;

        // Copies non-react specific statics from a child component to a parent component
        hoistNonReactStatics(WithFinalForm, Component);
        return WithFinalForm;
    };
}
